// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.requesterNotesForReferee {
  color: #19419b;
  font-size: 13px;
  cursor: pointer;
}
.requesterNotesForReferee .plusButton {
  display: inline-block;
  height: 13px;
  width: 13px;
  line-height: 5px;
  font-size: 19px;
  border: 1px solid #19419b;
  border-radius: 2px;
  padding-left: 1px;
}
.requesterNotesForReferee .minusButton {
  font-weight: bold;
}
.requesterNotesForReferee span:last-child {
  margin-left: 7px;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/RequesterNotesForReferee.less"],"names":[],"mappings":"AAEA;EAGC,cAAA;EACA,eAAA;EACA,eAAA;AAHD;AAFA;EAQE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAHF;AAZA;EAmBE,iBAAA;AAJF;AAfA;EAuBE,gBAAA;AALF","sourcesContent":["@import (reference) '../constants.less';\n\n.requesterNotesForReferee {\n\t@mainColour: #19419b;\n\n\tcolor: @mainColour;\n\tfont-size: 13px;\n\tcursor: pointer;\n\n\t.plusButton {\n\t\tdisplay: inline-block;\n\t\theight: 13px;\n\t\twidth: 13px;\n\t\tline-height: 5px;\n\t\tfont-size: 19px;\n\t\tborder: 1px solid @mainColour;\n\t\tborder-radius: 2px;\n\t\tpadding-left: 1px;\n\t}\n\n\t.minusButton {\n\t\tfont-weight: bold;\n\t}\n\n\tspan:last-child {\n\t\tmargin-left: 7px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
